import { useLang } from '../i18n';

/*
    Two letters, not a dropdown. There are exactly two languages, and someone who
    has landed on the wrong one cannot read a dropdown label to find their way
    out — "TR" and "EN" are legible whichever one they can read.
*/
export default function LanguageToggle() {
    const lang = useLang((s) => s.lang);
    const setLang = useLang((s) => s.setLang);

    return (
        <div
            style={{
                display: 'flex',
                gap: 2,
                padding: 2,
                flex: '0 0 auto',
                background: 'var(--chip-bg)',
                border: '1px solid var(--border)',
                borderRadius: 'var(--r-btn)',
            }}
        >
            {(['tr', 'en'] as const).map((code) => {
                const on = lang === code;
                return (
                    <button
                        key={code}
                        data-hit
                        onClick={() => setLang(code)}
                        lang={code}
                        aria-pressed={on}
                        style={{
                            width: 26,
                            height: 20,
                            border: 'none',
                            borderRadius: 6,
                            background: on ? 'var(--surface)' : 'transparent',
                            /* --text-dim, --text-mute değil: seçili olmayan kod --chip-bg
                               zemininde 10 pikselde 4.38:1 veriyordu ve AA 4.5 istiyor. Bu ekran
                               (giriş) axe ile bugüne kadar HİÇ taranmamıştı. */
                            color: on ? 'var(--accent-strong)' : 'var(--text-dim)',
                            fontFamily: 'var(--font-mono)',
                            fontSize: 'var(--fs-2xs)',
                            fontWeight: on ? 600 : 400,
                            letterSpacing: '0.5px',
                        }}
                    >
                        {code.toUpperCase()}
                    </button>
                );
            })}
        </div>
    );
}
